import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "margin-b-standard" }
const _hoisted_2 = { class: "margin-b-standard" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Good naming makes it easier to find files/references later", -1)
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

import Hint from "@/components/Hint.vue";
import { onMounted, ref } from "vue";
import { useUIFilesStore } from "@/stores/ui-files.store";
import { useFileManager } from "@/composables/files-manager";
import RightSidebarTitle from "@/components/right-sidebars/ui/RightSidebarTitle.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UploadForm',
  setup(__props) {

const uiFilesStore = useUIFilesStore();
const { uploadFile } = useFileManager();

const fileUploadInput = ref<HTMLInputElement | null>(null);
onMounted(() => {
  if (fileUploadInput.value) {
    fileUploadInput.value.focus();
  }
});

const fileToUpload = ref<File | undefined>(undefined);
const fileUploadName = ref<string>("");

const fetchLocalFile = (): void => {
  if (fileUploadInput.value && fileUploadInput.value.files) {
    fileToUpload.value = fileUploadInput.value.files[0];
    const suggestedName =
      fileToUpload.value.name.substring(
        0,
        fileToUpload.value.name.lastIndexOf(".")
      ) || fileToUpload.value.name;
    fileUploadName.value = fileUploadName.value
      ? fileUploadName.value
      : suggestedName;
  }
};
const uploadFileToProduct = (): void => {
  if (
    uiFilesStore.productToAttachFile &&
    uiFilesStore.fileAttachmentType &&
    fileToUpload.value
  ) {
    const formData = new FormData();
    formData.append("file", fileToUpload.value);
    formData.append("name", fileUploadName.value);
    formData.append("product_id", `${uiFilesStore.productToAttachFile.id}`);
    formData.append("attachment_type", `${uiFilesStore.fileAttachmentType}`);
    const payload = {
      formData: formData,
      productId: uiFilesStore.productToAttachFile.id
    };
    uploadFile(payload);
  }
};
const uploadFileToSection = (): void => {
  if (uiFilesStore.sectionToAttachFile && fileToUpload.value) {
    const formData = new FormData();
    formData.append("file", fileToUpload.value);
    formData.append("name", fileUploadName.value);
    formData.append(
      "product_id",
      `${uiFilesStore.sectionToAttachFile.product_id}`
    );
    formData.append("section_id", `${uiFilesStore.sectionToAttachFile.id}`);
    if (uiFilesStore.shouldBeSetAsMediaContent) {
      formData.append("is_media_content", "true");
    }
    const payload = {
      formData: formData,
      productId: uiFilesStore.sectionToAttachFile.product_id
    };
    uploadFile(payload);
  }
};
const handleFileUpload = (): void => {
  if (uiFilesStore.sectionToAttachFile) {
    uploadFileToSection();
  } else {
    uploadFileToProduct();
  }
  uiFilesStore.closeAttachFileModal();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(handleFileUpload, ["prevent"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(RightSidebarTitle, { title: 'Select a file:' }),
      _createElementVNode("input", {
        type: "file",
        id: "file-upload-input",
        ref_key: "fileUploadInput",
        ref: fileUploadInput,
        "data-testing": "file-upload-input",
        onChange: fetchLocalFile
      }, null, 544)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(RightSidebarTitle, { title: 'Name:' }, {
        default: _withCtx(() => [
          _createVNode(Hint, {
            type: 'info',
            position: 'right'
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fileUploadName).value = $event))
      }, null, 512), [
        [
          _vModelText,
          fileUploadName.value,
          void 0,
          { trim: true }
        ]
      ])
    ]),
    _createElementVNode("button", {
      "data-testing": "upload-attachfile-btn",
      disabled: !fileToUpload.value,
      class: "btn-1 full-width submit-btn"
    }, [
      (_unref(uiFilesStore).shouldBeSetAsMediaContent)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Set as Media Content"))
        : (_openBlock(), _createElementBlock("span", _hoisted_6, "Attach content"))
    ], 8, _hoisted_4)
  ], 32))
}
}

})